import React from 'react';
import styles from './MailTemplateSent.module.scss';
import MailHeader from './components/MailHeader';
import MailContent from './components/MailContent';
import { IconWrapper } from '../../../Atoms/icons/Icon';
import { useFetchMailById } from '../../../../Hooks/Mail';
import Loader from '../../Loader/Loader';

const MailTemplateSent = ({
  selectedMail,
  setReply,
  setIsNewMail,
  onDelete,
  setRefresh,
}) => {
  const {
    data: mailById,
    isLoading,
    refetch,
  } = useFetchMailById(selectedMail?.id);

  return isLoading ? (
    <div className={styles['noMail_Container']}>
      <Loader />
    </div>
  ) : !selectedMail ? (
    <div className={styles['noMail_Container']}>
      <div>
        <IconWrapper icon='noMail' />
        <p>No mail selected</p>
        <span>Please select an email to read</span>
      </div>
    </div>
  ) : (
    <div className={styles['templateContainer']}>
      <MailHeader
        setReply={setReply}
        setIsNewMail={setIsNewMail}
        onDelete={onDelete}
        mailById={mailById?.data}
      />
      <MailContent
        mailById={mailById?.data}
        refetch={refetch}
        setRefresh={setRefresh}
      />
    </div>
  );
};

export default MailTemplateSent;
